import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/Dashboard.css';
import TitleComponent from '../components/TitleComponent/TitleComponent';
import OrderComponent from '../components/OrderComponent/OrderComponent';
import { ICONS } from '../constants/constants';
import { useLocation } from 'react-router-dom';

const OrderDetails = () => {
  
  const location = useLocation();
  const order = location.state?.order;
  // const { id } = useParams();
  function formatDate(date) {
    if (!date) return null;
  
    return new Date(date).toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Karachi' // change if needed
    });
  }
  console.log('order', order);
  const orderData = {
    orderId: order.id || "N/A",
    orderFrom: order?.supplierUser?.name || "N/A",
    orderBy:  order?.farmerUser?.name || "N/A",
    orderPlaced: formatDate(order.created_at) || "N/A",
    products: order?.orderItems?.map(item => ({
      image: item?.product?.product_image || "N/A",
      name: item?.product?.productName || "N/A",
      unit: item?.quantity || "N/A",  // Use quantity from orderItems
      price: item?.totalCost || "N/A", // Use totalCost from orderItems
    })) || [],
    totalAmount: order.totalCost || "N/A",
  }


  
 

  return (
    <Container>
      <Row>
     <Col lg={12} className="breadcrum-container ">
               <Row className="breadcrum-container  py-3">
            <Col lg={12}>
              <div className="custom-breadcrumb">
                {/* <span><a href="/">Home</a></span> */}
                {orderData.orderBy ? (
                  <>
                    <img src={ICONS.farmer} className="icon" alt="farmer-icon" />
                    <span>
                      <a href="/farmers">Farmers</a>
                    </span>
                  </>
                ) : (
                  <>
                    <img src={ICONS.supplier} className="icon" alt="supplier-icon" />
                    <span>
                      <a href="/suppliers">Suppliers</a>
                    </span>
                  </>
                )}
                {/* <span>
                  <a href="/supplier">{userData.name}({userData.id})</a>
                </span> */}
                <span>
                  Order ID({orderData.orderId})
                </span>
              </div>
            </Col>
          </Row>
        </Col>
      {/* <Col lg={12}>
    <div className="custom-breadcrumb">
     
<img src={ICONS.supplier} className='icon'/>
      <span><a href="/suppliers">Suppliers</a></span>
      <span><a href="/supplier">Andrew</a></span>
      <span>Orders</span>
    </div>
  </Col> */}
        <Col lg={12} className='component-container mb-2'>
        <TitleComponent title="Order Details" />
        <OrderComponent order={orderData} />
        </Col>

       
      </Row>
    </Container>
  );
};

export default OrderDetails;
